import { InjectionToken } from '@angular/core';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import updateLocale from 'dayjs/plugin/updateLocale';
dayjs.extend(localeData);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 1 });

export const LOCALE_CONFIG = new InjectionToken<LocaleConfig>(
  'date-range-picker.config'
);
/**
 *  LocaleConfig Interface
 */
export interface LocaleConfig {
  [index: string]: string | string[] | number | undefined;

  direction?: string;
  separator?: string;
  weekLabel?: string;
  applyLabel?: string;
  cancelLabel?: string;
  clearLabel?: string;
  customRangeLabel?: string;
  daysOfWeek?: string[];
  monthNames?: string[];
  firstDay?: number;
  format?: string;
  displayFormat?: string;
}
/**
 *  DefaultLocaleConfig
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const DefaultLocaleConfig: LocaleConfig = {
  direction: 'ltr',
  separator: ' - ',
  weekLabel: 'W',
  applyLabel: 'Apply',
  cancelLabel: 'Cancel',
  clearLabel: 'Clear',
  customRangeLabel: 'Custom range',
  daysOfWeek: dayjs.weekdaysShort(),
  monthNames: dayjs.months(),
  firstDay: dayjs.localeData().firstDayOfWeek()
};
